import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from './client'
import { queryKeys } from '../lib/query'

// Types
export interface UserSummary {
  id: string
  email: string
  username: string
  role: string
  telegramUsername?: string | null
}

// Get all users (for dropdowns, assignments)
export function useUsers() {
  return useQuery({
    queryKey: queryKeys.users.all,
    queryFn: () => apiClient<UserSummary[]>('/users'),
  })
}

// Update profile
export function useUpdateProfile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: { username?: string; email?: string }) =>
      apiClient<UserSummary>('/users/me', {
        method: 'PATCH',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.me })
    },
  })
}

// Change password
export function useChangePassword() {
  return useMutation({
    mutationFn: (data: { currentPassword: string; newPassword: string }) =>
      apiClient('/users/me/password', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
  })
}
